import React, { useState } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { Ethnicity } from '../../model/data/Ethnicity';
import { useDashboard } from '../../model/DashboardContext';

const EthnicitySelector: React.FC = () => {
    const { dashboard, updateSelectedEthnicities } = useDashboard();
    const [selectedEthnicities, setSelectedEthnicities] = useState<Set<Ethnicity>>(
        dashboard ? new Set(dashboard.selectedEthnicities) : new Set([Ethnicity.white])
    );

    const handleToggle = (ethnicity: Ethnicity) => {
        if (!dashboard) {
            return;
        }

        const newSelected = new Set(selectedEthnicities);
        if (newSelected.has(ethnicity)) {
            newSelected.delete(ethnicity);
        } else {
            newSelected.add(ethnicity);
        }
        setSelectedEthnicities(newSelected);
        updateSelectedEthnicities(newSelected);
    };

    return (
        <FormControl fullWidth sx={{ width: '700px' }}>
            <Select
                labelId="ethnicity-select-label"
                multiple
                value={Array.from(selectedEthnicities)} // Display the selected ethnicities
                renderValue={(selected) => (selected as Ethnicity[]).join(', ')}
                variant="standard"
                sx={{ fontSize: '0.8rem' }}
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'top',   // Anchor to the top of the input
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'bottom', // Dropdown grows upwards
                        horizontal: 'left',
                    },
                }}
            >
                {Object.values(Ethnicity).map((ethnicity) => (
                    <MenuItem
                        key={ethnicity}
                        value={ethnicity}
                        onClick={() => handleToggle(ethnicity)}
                        sx={{
                            fontWeight: selectedEthnicities.has(ethnicity) ? 'bold' : 'normal',
                            backgroundColor: selectedEthnicities.has(ethnicity) ? 'rgba(0, 0, 0, 0.1)' : 'transparent',
                        }}
                    >
                        {ethnicity}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default EthnicitySelector;
